import axios from 'axios';

export default class BookingService {
    /**
     * Get a booking.
     *
     * @param {String} token
     * @return {AxiosPromise<any>}
     */
    static get(token) {
        return axios.get(this.endpoint() + '/' + token);
    }

    /**
     * Add a booking.
     *
     * @param {Booking} booking
     * @return {AxiosPromise<any>}
     */
    static add(booking) {
        return axios.post(this.endpoint(), booking);
    }

    /**
     * Get endpoint of API.
     *
     * @return {string}
     */
    static endpoint() {
        return 'bookings';
    }
}
